import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useContext } from 'react';
import { ThemeContext } from '../../../lib/contexts/ThemeContext';

export default function ControlledAccordion({ title, description, contents, expanded, onChange }) {
  const {
    state: { finalTheme },
  } = useContext(ThemeContext);

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={onChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: '33%', flexShrink: 0 }}>{title}</Typography>
          <Typography sx={{ color: finalTheme.themeName == 'Light' ? 'text.secondary' : 'white' }}>
            {description}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{contents}</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
